<template>
	<div class="relative w-full">
		<app-tabs name="Driver App" :nav justify lazy-load>
			<template #default>
				<div v-if="app.isToday()" class="mt-4">
					<app-button
						v-if="auth.vehicle && !auth.vehicleLocked"
						class="w-full"
						theme="info"
						size="large"
						@click="confirmVehicle = true">
						Start Journey
					</app-button>

					<app-button
						v-else-if="auth.vehicle && auth.vehicleLocked"
						class="w-full"
						theme="danger"
						size="large"
						@click="auth.setVehicle(null)">
						Cancel Journey
					</app-button>

					<app-alert v-else theme="warning" spacing="mb-0">
						Please select your vehicle to begin your day
					</app-alert>
				</div>
			</template>

			<template #tab1>
				<JourneyList v-if="auth.user?.current_vehicle" />
			</template>

			<template #tab2>
				<JourneyList v-if="auth.user?.current_vehicle" type="DEL" />
			</template>

			<template #tab3>
				<JourneyList v-if="auth.user?.current_vehicle" type="COL" />
			</template>
		</app-tabs>
	</div>

	<confirm
		:open="confirmVehicle"
		title="Start Journey?"
		theme="info"
		@canceled="confirmVehicle = false"
		@confirmed="(auth.setVehicle(auth.vehicle ?? null), (confirmVehicle = false))">
		This will lock you into the vehicle on the app. Proceed?
	</confirm>
</template>

<script lang="ts" setup>
	import { ref } from 'vue'
	import useAppStore from '@/stores/app'
	import useAuthStore from '@/stores/auth'
	import JourneyList from '@/components/partials/driver-app/JourneyList.vue'
	import Confirm from '@/components/partials/dialogs/Confirm.vue'

	const app = useAppStore()
	const auth = useAuthStore()
	const confirmVehicle = ref(false)

	const nav = [
		{
			id: 'all',
			name: 'All',
			icon: ['fas', 'road']
		},
		{
			id: 'delivery',
			name: 'Delivery',
			icon: ['fas', 'truck-arrow-right']
		},
		{
			id: 'collection',
			name: 'Collection',
			icon: ['fas', 'truck-arrow-right'],
			iconClasses: 'scale-x-[-1]'
		}
	]
</script>
